
import EnvironmentModel from "./environment.model"

let env: EnvironmentModel = {
    env: "dev",
    serverUrl: "http://localhost:8888/sites/back",
    frontUrl: "http://localhost:3000",
};

const getEnv = (urlAtual: string) => {
    if ((urlAtual).indexOf('localhost') >= 0) { // local
        env = {
            env: "local",
            serverUrl: "http://localhost:8888/sites/back",
            frontUrl: "http://localhost:3000",
        };
    } else if ((urlAtual).indexOf('sites-hml') >= 0) { // hml
        env = {
            env: "hml",
            serverUrl: "https://sites.a7apps.com/back",
            frontUrl: "https://sites-hml.a7apps.com",
        };
    } else {
        env = {
            env: "prd",
            serverUrl: "https://sites.a7apps.com/back",
            frontUrl: "https://sites.a7apps.com",
        };
    }
    
    return env;
}

export const environment: EnvironmentModel = getEnv(window.location.host);
